export const summaryLabTests_style = {
  divideDottedSx: {
    my: 2,
    borderStyle: 'dashed',
    borderColor: 'divider',
  },
  cardSxx: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  commonTextSx: {
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 600,
  },
  issuesTextSx: {
    color: 'text.hint',
    fontSize: '12px',
    fontWeight: 500,
    mt: 1,
  },
  inputValueSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    bgcolor: '#F5F5F5',
    pt: 1,
    pb: 1.2,
    borderRadius: 1,
  },
  inputSx: {
    width: '100%',
    bgcolor: '#F5F5F5',
    pt: 1,
    pb: 1.2,
    borderRadius: 1,
  },
  inputTextSx: {
    fontSize: '16px',
    color: 'text.primary',
    fontWeight: '500',
    pl: 1,
    display: 'flex',
  },
  inputValueIconSx: {
    display: 'flex',
    alignItems: 'flex-end',
    pr: '20px',
  },
  subCommonTextSx: {
    color: 'text.hint',
    fontSize: '12px',
  },
  dividerSx: {
    // my: 1.2,
    borderStyle: 'dashed',
    borderColor: 'divider',
  },
  addSummaryTitleSx: {
    color: '#808080',
    fontSize: '12px',
    pb: 0.5,
  },
  rootSx: {
    mt: 2,
  },
  inputTextShowSx: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    bgcolor: '#F5F5F5',
    pt: 1,
    pb: 1.2,
    pl: 1,
    borderRadius: '8px',
  },
  summaryTitlesx: {
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 500,
  },
  boxCardSx: {
    bgcolor: '#F5F5F5',
    borderRadius: '8px',
    p: 2,
    mb: 1.5,
  },
  valTextSx: {
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 600,
  },
};
